/** Serializable option for the MUI place-search Autocomplete. */
export type VenuePlaceSearchOption = {
  placeId: string;
  label: string;
  mainText: string;
  secondaryText: string;
};

function formattableToString(value: { toString(): string } | null | undefined): string {
  if (!value) {
    return "";
  }
  return String(value.toString()).trim();
}

/**
 * Map Places AutocompleteSuggestion results into MUI Autocomplete options.
 * Keeps `prediction` off the public option shape so list identity stays stable.
 */
export function mapPlaceSuggestionsToOptions(
  suggestions: Array<{
    placePrediction: {
      placeId: string;
      text?: { toString(): string } | null;
      mainText?: { toString(): string } | null;
      secondaryText?: { toString(): string } | null;
    } | null;
  }>
): VenuePlaceSearchOption[] {
  const options: VenuePlaceSearchOption[] = [];
  for (const suggestion of suggestions) {
    const prediction = suggestion.placePrediction;
    if (!prediction?.placeId) {
      continue;
    }
    const mainText = formattableToString(prediction.mainText);
    const secondaryText = formattableToString(prediction.secondaryText);
    const label =
      formattableToString(prediction.text) ||
      [mainText, secondaryText].filter(Boolean).join(", ") ||
      prediction.placeId;
    options.push({
      placeId: prediction.placeId,
      label,
      mainText: mainText || label,
      secondaryText,
    });
  }
  return options;
}
